import { progressAnatomy as r } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const { defineMultiStyleConfig: t } = e(r.keys), s = t({
  sizes: {
    sm: {
      track: { h: 2 }
    },
    md: {
      track: { h: 3 }
    },
    lg: {
      track: { h: 4 }
    }
  },
  baseStyle: {
    filledTrack: {
      bg: "green.500",
      transition: "width 0.3s ease-in-out"
    },
    track: {
      bg: "gray.100",
      "&.gravity-progress__appear-full": {
        div: {
          w: "100% !important"
        }
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "normal"
  },
  variants: {
    normal: {
      filledTrack: {
        bg: "green.500"
      }
    },
    error: {
      filledTrack: {
        bg: "red.500"
      }
    }
  }
});
export {
  s as default
};
